export default "__VITE_ASSET__CaNQk3fM__"